var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path, _path2, _path3, _g17, _g18, _g19, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g20, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _path18, _path19, _path20, _path21, _g39, _path22, _path23, _path24, _path25, _path26, _path27, _g40, _g41, _g42, _g43, _g44, _g45, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g46, _path35, _path36, _path37, _g47, _g48, _path38, _g49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbuOn24Phase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 934.38 1468.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ibu-on24-disable-rect{\n        fill: #edeef0;\n      }\n      .ibu-on24-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;  \n      }\n      .cls-1-ibu-on24-p1 {\n        stroke: #008a0e;\n      }\n\n      .cls-1-ibu-on24-p1, .cls-2-ibu-on24-p1, .cls-3-ibu-on24-p1 {\n        stroke-width: .05px;\n      }\n\n      .cls-1-ibu-on24-p1, .cls-4-ibu-on24-p1 {\n        fill: #008a0e;\n      }\n\n      .cls-5-ibu-on24-p1, .cls-6-ibu-on24-p1, .cls-7-ibu-on24-p1, .cls-2-ibu-on24-p1, .cls-8-ibu-on24-p1, .cls-9-ibu-on24-p1, .cls-10-ibu-on24-p1 {\n        stroke: #1071e5;\n      }\n\n      .cls-5-ibu-on24-p1, .cls-11-ibu-on24-p1 {\n        fill: #fff;\n      }\n\n      .cls-6-ibu-on24-p1, .cls-7-ibu-on24-p1, .cls-2-ibu-on24-p1 {\n        fill: #1071e5;\n      }\n\n      .cls-12-ibu-on24-p1, .cls-13-ibu-on24-p1, .cls-11-ibu-on24-p1, .cls-14-ibu-on24-p1, .cls-15-ibu-on24-p1, .cls-4-ibu-on24-p1 {\n        stroke-width: 0px;\n      }\n\n      .cls-12-ibu-on24-p1, .cls-8-ibu-on24-p1, .cls-9-ibu-on24-p1 {\n        fill: none;\n      }\n\n      .cls-13-ibu-on24-p1 {\n        fill: #e81313;\n      }\n      \n      .cls-7-ibu-on24-p1, .cls-8-ibu-on24-p1 {\n        stroke-width: .5px;\n      }\n\n      .cls-14-ibu-on24-p1 {\n        fill: #3a414a;\n      }\n\n      .cls-16-ibu-on24-p1 {\n        fill: transparent;\n      }\n\n      .cls-15-ibu-on24-p1, .cls-3-ibu-on24-p1 {\n        fill: #e81313;\n      }\n\n      .cls-3-ibu-on24-p1 {\n        stroke: #e81313;\n      }\n\n      .cls-10-ibu-on24-p1 {\n        fill: url(#linear-gradient-ibu-on24-p1);\n      }\n      .cls-10-ibu-on24-p1:hover {\n        fill: url(#linear-gradient-ibu-on24-p1);\n        pointer-events: none;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ibu-on24-p1",
    x1: 4144.42,
    y1: 1199.01,
    x2: 4144.42,
    y2: 1045.92,
    gradientTransform: "translate(-3679.5 2328) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M.5,270c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-14-ibu-on24-p1",
    d: "M31.24,309.31l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM28.66,302.58l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-14-ibu-on24-p1",
    d: "M39.39,296.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM40,297.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-14-ibu-on24-p1",
    d: "M54.53,309.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M61.05,293.62v-2.04h2.17v2.04h-2.17ZM61.05,309.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M73.95,299.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M83.8,296.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM87.33,301.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M106.88,292.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM106.88,307.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-14-ibu-on24-p1",
    d: "M130.78,297.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-14-ibu-on24-p1",
    d: "M136.01,309.31v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M163.32,291.43c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM163.32,306.85c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M180.64,295.3c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31h0ZM180.11,307.12c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M195.58,298.77c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M217.49,297.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M233.11,306.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM226.8,305.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-14-ibu-on24-p1",
    d: "M245.06,296.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-2",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M260.27,306.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM253.96,305.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-14-ibu-on24-p1",
    d: "M276.3,296.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM270.66,307.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M284.65,296.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM288.18,301.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-14-ibu-on24-p1",
    d: "M299.18,298.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M313.1,296.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM313.03,307.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M326.75,293.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M143.79,322.95v-2.04h2.17v2.04h-2.17ZM143.79,338.64v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M155.47,325.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M165.11,335.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M174.68,325.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM178.21,330.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M189.42,325.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M199.06,335.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12-ibu-on24-p1",
    d: "M.5,270c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M.5,590c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M76.46,628.76c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM76.46,644.18c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-14-ibu-on24-p1",
    d: "M98.87,645.81l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M110.41,628.76c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-14-ibu-on24-p1",
    d: "M127.66,642v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM125.62,631.41c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M145.31,632.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM144.77,644.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-14-ibu-on24-p1",
    d: "M152.72,645.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-3",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M166.02,643.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM159.71,642.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M174.04,642.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M183.68,629.92c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M190.4,632.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM190.33,644.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M204.93,634.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M219.53,634.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-14-ibu-on24-p1",
    d: "M240.17,632.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM239.63,644.45c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-14-ibu-on24-p1",
    d: "M251.65,646.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M261.15,630.12v-2.04h2.17v2.04h-2.17ZM261.15,645.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M266.52,645.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M274.26,642.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M.5,430c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M64.14,441.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM64.14,456.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-14-ibu-on24-p1",
    d: "M88.04,446.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-14-ibu-on24-p1",
    d: "M93.27,458.31v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-4",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M123.82,441.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM123.82,456.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-3",
    "data-name": "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M141.14,445.13c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM140.6,456.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M156.08,448.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-14-ibu-on24-p1",
    d: "M182.22,458.31l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-4",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M195.8,455.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM189.48,454.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-4",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M207.75,445.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-5",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M222.96,455.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM216.65,454.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "cls-14-ibu-on24-p1",
    d: "M238.98,445.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM233.35,456.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M247.34,445.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM250.87,450.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M261.87,447.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M273,455.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M282.58,445.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM282.51,456.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M38.64,476.57c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M45.77,474.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM49.3,479.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-14-ibu-on24-p1",
    d: "M59.08,476.16c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M71.57,474.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM75.1,479.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M79.99,471.95v-2.04h2.17v2.04h-2.17ZM79.99,487.64v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-2",
    "data-name": "aa",
    className: "cls-14-ibu-on24-p1",
    d: "M91.06,487.64h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M102.74,474.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM106.27,479.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-14-ibu-on24-p1",
    d: "M122.84,476.16c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M135.33,474.47c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM135.27,486.28c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-4",
    "data-name": "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M149.93,474.47c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM149.39,486.28c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-14-ibu-on24-p1",
    d: "M167.86,474.74l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-6",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M181.51,474.47c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM181.44,486.28c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M195.15,471.75c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-14-ibu-on24-p1",
    d: "M204.12,487.64v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M219.53,478.74c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM212.94,478c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM212.94,485.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M240.72,481.32c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-5",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M258.85,470.6c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM258.85,486.01c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-14-ibu-on24-p1",
    d: "M281.25,487.64l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M292.8,470.6c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-14-ibu-on24-p1",
    d: "M310.04,483.84v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM308.01,473.24c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-5",
    "data-name": "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M135.77,503.8c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM135.23,515.61c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M143.18,516.97v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-6",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M156.48,514.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM150.17,513.37c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M164.5,513.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M174.14,501.08c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-7",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M180.86,503.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM180.79,515.61c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M195.39,505.9c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M209.99,505.5c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M171.63,377v30.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M172.13,377h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M171.63,421.88l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M293.8,943.5c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M383.33,982.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM385.57,990.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M399.22,999.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-7",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M412.53,996.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM406.21,995.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-7",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M420.54,996.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M430.18,983.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-8",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M436.91,986.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM436.84,997.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M451.44,988.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M466.04,987.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M486.61,988.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-8",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M493.74,986.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM497.27,991.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-3",
    "data-name": "aa",
    className: "cls-14-ibu-on24-p1",
    d: "M507.86,999.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-5",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M514.38,983.62v-2.04h2.17v2.04h-2.17ZM514.38,999.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-9",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M524.91,986.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM528.44,991.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-14-ibu-on24-p1",
    d: "M545.68,999.31h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M464.91,1050.5l.02,64.02"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M465.41,1050.5h-.98v-.5h1l-.02.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M464.91,1129.28l-4.62-14.26h9.27l-4.65,14.26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M465.91,1343.07h-1.98v-32.07h2l-.02,32.07ZM465.93,1281.67h-2v-.5h2v.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M465.91,1281.2h-1.98v-4.03h2l-.02,4.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M464.91,1358.33l-4.62-14.26h9.27l-4.65,14.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M464.91,1361.57l-6-18.5h12.03l-6.03,18.5ZM461.67,1345.07l3.26,10.03,3.25-10.03h-6.51Z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-4-ibu-on24-p1",
    d: "M453.78,1294.29v6.93h-3.53v-6.93l-5.98-9.91h3.67l4.07,7.13,4.07-7.13h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-4-ibu-on24-p1",
    d: "M471.37,1297.96c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM468.31,1293.27c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-4-ibu-on24-p1",
    d: "M481.69,1291.84c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M171.63,537v30.12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M172.13,537h-1v-.5h1v.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M171.63,581.88l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M171.63,217.5v29.62"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M172.13,217.5h-1v-.5h1v.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M171.63,261.88l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1 ibu-on24-disable-rect",
    d: "M711.63,1155.54c0-3.31,2.69-6,6-6h203.58c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-203.57c-3.31,0-6-2.69-6-6v-100Z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "cls-14-ibu-on24-p1",
    d: "M754.61,1168.31c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-14-ibu-on24-p1",
    d: "M765,1168.99c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-8",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M780.96,1178.02c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM774.64,1176.87c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-5",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M792.91,1167.29c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-3",
    "data-name": "am",
    className: "cls-14-ibu-on24-p1",
    d: "M810.56,1167.56c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM804.93,1178.97c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-10",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M818.91,1167.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM822.44,1172.79c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M834.87,1170.76c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-8",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M848.72,1177.27c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-9",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M858.3,1167.29c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM858.23,1179.11c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-14-ibu-on24-p1",
    d: "M879.69,1167.29c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM879.14,1179.11c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-11",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M892.25,1167.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM895.78,1172.79c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-5",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M727.76,1200.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-14-ibu-on24-p1",
    d: "M736.52,1210.07c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-14-ibu-on24-p1",
    d: "M752.2,1196.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM751.66,1208.44c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M772.23,1198.32c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-6",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M779.9,1194.11v-2.04h2.17v2.04h-2.17ZM779.9,1209.8v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-9",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M787.64,1206.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-12",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M797.22,1196.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM800.75,1202.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "cls-14-ibu-on24-p1",
    d: "M809.78,1196.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM810.39,1198.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "x-2",
    "data-name": "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-10",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M828.39,1206.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-10",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M837.96,1196.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM837.89,1208.44c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "q-2",
    "data-name": "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-14-ibu-on24-p1",
    d: "M853.78,1209.8v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M869.19,1200.9c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM862.61,1200.16c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM862.61,1207.97c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M890.38,1203.48c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-11",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M905.79,1196.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM905.73,1208.44c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-8",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M920.32,1198.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-6",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M772.84,1222.09c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM772.84,1237.5c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "cls-14-ibu-on24-p1",
    d: "M796.74,1226.98c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-14-ibu-on24-p1",
    d: "M801.97,1239.13v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M825.06,1222.29c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM827.3,1230.78c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-7",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M848.82,1222.09c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM848.82,1237.5c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-5",
    "data-name": "af",
    className: "cls-14-ibu-on24-p1",
    d: "M872.73,1226.98c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M.5,110.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "cls-14-ibu-on24-p1",
    d: "M32.77,166.31v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M48.18,157.41c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM41.6,156.66c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM41.6,164.47c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M69.37,159.99c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ad-13",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M84.78,153.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM88.31,158.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M93.61,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM95.85,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M114.73,149.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M123.48,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM125.73,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-14-ibu-on24-p1",
    d: "M145.15,160.74v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-8",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M161.65,149.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM161.65,164.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-14-ibu-on24-p1",
    d: "M184.05,166.31l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M195.6,149.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-14-ibu-on24-p1",
    d: "M212.84,162.5v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM210.81,151.91c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M224.73,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM226.97,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M240.61,166.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-9",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M253.92,163.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM247.61,162.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-11",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M261.94,163.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-6",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M271.58,150.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-12",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M278.3,153.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM278.23,164.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-9",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M292.83,155.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-6",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M307.43,154.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "rect9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-ibu-on24-p1",
    d: "M459.52,1131.62c3.41-1.67,7.39-1.67,10.8,0l145.85,71.28c1.46.71,2.06,2.46,1.35,3.92-.29.59-.76,1.07-1.35,1.35l-145.86,71.28c-3.4,1.66-7.38,1.66-10.78,0l-145.86-71.28c-1.46-.71-2.06-2.46-1.35-3.92.29-.59.76-1.07,1.35-1.35l145.85-71.28Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-11-ibu-on24-p1",
    d: "M385.29,1177.21c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM387.53,1185.69c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-11-ibu-on24-p1",
    d: "M401.18,1194.05v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-11-ibu-on24-p1",
    d: "M414.49,1191.6c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM408.17,1190.45c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-11-ibu-on24-p1",
    d: "M422.5,1190.85c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-11-ibu-on24-p1",
    d: "M432.14,1178.16c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-11-ibu-on24-p1",
    d: "M438.86,1180.87c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM438.79,1192.69c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-11-ibu-on24-p1",
    d: "M453.39,1182.98c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-11-ibu-on24-p1",
    d: "M467.99,1182.57c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "cls-11-ibu-on24-p1",
    d: "M495.08,1182.57c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-11-ibu-on24-p1",
    d: "M507.92,1180.87c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM511.45,1186.37c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-11-ibu-on24-p1",
    d: "M521.5,1180.87c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM525.03,1186.37c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "cls-11-ibu-on24-p1",
    d: "M532.29,1190.85c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-11-ibu-on24-p1",
    d: "M544.24,1184.34c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR-3",
    "data-name": "aR",
    className: "cls-11-ibu-on24-p1",
    d: "M396.23,1210.21c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM399.76,1215.71c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-11-ibu-on24-p1",
    d: "M412.59,1223.38l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-11-ibu-on24-p1",
    d: "M423.05,1210.21c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM422.51,1222.02c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-4",
    "data-name": "aR",
    className: "cls-11-ibu-on24-p1",
    d: "M435.61,1210.21c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM439.14,1215.71c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-11-ibu-on24-p1",
    d: "M448.92,1211.9c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-3",
    "data-name": "aM",
    className: "cls-11-ibu-on24-p1",
    d: "M458.63,1220.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "cls-11-ibu-on24-p1",
    d: "M470.99,1220.93c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM464.67,1219.78c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-4",
    "data-name": "aM",
    className: "cls-11-ibu-on24-p1",
    d: "M479,1220.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-11-ibu-on24-p1",
    d: "M483.41,1207.69v-2.04h2.17v2.04h-2.17ZM483.41,1223.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-11-ibu-on24-p1",
    d: "M493.94,1210.21c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM493.87,1222.02c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-11-ibu-on24-p1",
    d: "M508.67,1210.21c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-11-ibu-on24-p1",
    d: "M523.48,1213.67c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-11-ibu-on24-p1",
    d: "M533.53,1206.34c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM531.76,1223.38v-2.38h2.31v2.38h-2.31"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M642,1206.54h-24.33v-2h24.34v2ZM692.62,1206.54h-18.15v-2h18.15v2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M617.7,1206.54h-4.03v-2h4.02v2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M707.9,1205.54l-14.28,4.63v-9.27l14.28,4.64Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M711.13,1205.54l-18.5,6v-12.02l18.5,6.02ZM694.63,1208.79l10.02-3.26-10.03-3.26v6.52Z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-13-ibu-on24-p1",
    d: "M653.9,1210.42l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-13-ibu-on24-p1",
    d: "M667.07,1197.25c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM667.01,1208.39c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M819.42,1148.54v-142.92h-166.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M819.92,1149.04h-1v-.52h1v.52Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M638.16,1005.63l14.27-4.64v9.26l-14.27-4.62Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M171.63,697v123h293.28l.02,100.62"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M172.13,697h-1v-.5h1v.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M464.91,935.38l-4.62-14.26h9.27l-4.65,14.26Z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "rect10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16-ibu-on24-p1",
    d: "M137.25,1367.57c0-3.31,2.69-6,6-6h643.33c3.31,0,6,2.69,6,6v94.5c0,3.31-2.69,6-6,6H143.25c-3.31,0-6-2.69-6-6v-94.5Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-14-ibu-on24-p1",
    d: "M407.87,1406.23c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-14",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M418.4,1405.89c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM421.93,1411.39c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-15",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M431.98,1405.89c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM435.51,1411.39c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-6",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M447.59,1402.22c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM449.83,1410.71c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-2",
    "data-name": "aH",
    className: "cls-14-ibu-on24-p1",
    d: "M469.05,1407.59c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-10",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M485.01,1416.62c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM478.69,1415.47c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-6",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M498.18,1409.35c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-16",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M508.03,1405.89c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM511.56,1411.39c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-5",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M528.46,1402.02c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M591.63,110.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "C-2",
    "data-name": "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-4",
    "data-name": "az",
    className: "cls-14-ibu-on24-p1",
    d: "M623.9,166.31v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-4",
    "data-name": "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M639.31,157.41c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM632.72,156.66c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM632.72,164.47c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M660.49,159.99c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "D-2",
    "data-name": "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ad-17",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M675.91,153.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM679.44,158.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-7",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M684.73,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM686.98,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-6",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M705.85,149.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-8",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M714.61,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM716.85,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E-2",
    "data-name": "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "cls-14-ibu-on24-p1",
    d: "M736.27,160.74v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-9",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M752.77,149.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM752.77,164.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "cls-14-ibu-on24-p1",
    d: "M775.18,166.31l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-7",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M786.72,149.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-4",
    "data-name": "as",
    className: "cls-14-ibu-on24-p1",
    d: "M803.97,162.5v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM801.93,151.91c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F-2",
    "data-name": "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-9",
    "data-name": "aC",
    className: "cls-14-ibu-on24-p1",
    d: "M815.85,149.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM818.09,157.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M831.74,166.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-11",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M845.05,163.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM838.73,162.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-12",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M853.06,163.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-7",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M862.7,150.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-13",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M869.43,153.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM869.36,164.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-10",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M883.96,155.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-7",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M898.56,154.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1",
    d: "M591.63,270c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb-2",
    "data-name": "bb",
    className: "cls-14-ibu-on24-p1",
    d: "M627.09,296.47c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-14-ibu-on24-p1",
    d: "M636.52,309.58c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-14-ibu-on24-p1",
    d: "M652.21,296.13c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM651.67,307.95c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-8",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M672.24,297.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-7",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M679.91,293.62v-2.04h2.17v2.04h-2.17ZM679.91,309.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-13",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M687.65,306.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-14-ibu-on24-p1",
    d: "M703.75,297.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-3",
    "data-name": "aH",
    className: "cls-14-ibu-on24-p1",
    d: "M716.65,297.83c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-12",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M732.61,306.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM726.29,305.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-6",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M744.56,296.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-4",
    "data-name": "am",
    className: "cls-14-ibu-on24-p1",
    d: "M762.21,296.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM756.57,307.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-18",
    "data-name": "ad",
    className: "cls-14-ibu-on24-p1",
    d: "M770.56,296.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM774.09,301.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-7",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M786.52,299.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-14-ibu-on24-p1",
    d: "M789.57,309.58l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-13",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M805.94,306.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM799.62,305.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "cls-14-ibu-on24-p1",
    d: "M815.72,296.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM816.33,297.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-4",
    "data-name": "Z",
    className: "cls-14-ibu-on24-p1",
    d: "M829.3,296.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM829.91,297.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "cls-14-ibu-on24-p1",
    d: "M838.19,303.74v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-14",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M851.98,296.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM851.91,307.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-7",
    "data-name": "al",
    className: "cls-14-ibu-on24-p1",
    d: "M866.71,296.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-8",
    "data-name": "ac",
    className: "cls-14-ibu-on24-p1",
    d: "M881.51,299.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m-2",
    "data-name": "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-14",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M895.36,306.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-15",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M904.94,296.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM904.87,307.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-5",
    "data-name": "az",
    className: "cls-14-ibu-on24-p1",
    d: "M745.03,338.64v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-5",
    "data-name": "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M760.44,329.74c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM753.86,329c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM753.86,336.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M781.63,332.32c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M762.75,536.5v284l-297.85-.5.02,100.62"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M763.25,536.5h-1v-.5h1v.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M464.91,935.38l-4.62-14.26h9.27l-4.65,14.26Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9-ibu-on24-p1",
    d: "M762.75,217.5v29.62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M763.25,217.5h-1v-.5h1v.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6-ibu-on24-p1",
    d: "M762.75,261.88l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-ibu-on24-p1",
    d: "M53.8,6c0-3.31,2.69-6,6-6h228c3.31,0,6,2.69,6,6v74.3c0,3.31-2.69,6-6,6H59.8c-3.31,0-6-2.69-6-6V6Z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-14-ibu-on24-p1",
    d: "M117.49,41.23c0,6.81-4.35,9.78-10.96,9.78s-10.37-2.86-10.37-9.58v-15.31h5.04v14.91c-.1,3.75,1.88,5.83,5.43,5.93,8.89.1,4.84-12.84,5.73-20.84h5.14v15.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-14-ibu-on24-p1",
    d: "M138.83,50.61l-8.69-11.26-3.06,2.37v8.89h-5.14v-24.49h5.14v11.16l11.06-11.16h5.93l-10.47,10.37,11.36,14.12h-6.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-14-ibu-on24-p1",
    d: "M171.62,48.73c-4.35,3.75-15.51,2.96-15.01-4.84.3-4.25,2.86-5.93,5.83-7.41-2.47-4.35-1.19-10.96,5.23-10.47,3.65.3,6.32,1.48,6.32,5.14,0,4.25-3.95,5.14-6.81,6.72,1.19,2.17,2.67,4.05,4.25,5.83,1.38-1.88,2.07-3.75,2.77-6.32l3.65,1.28c-.79,2.86-1.88,5.14-3.36,7.31,1.19.99,3.16,1.58,5.14.99v3.46c-2.77,1.09-6.42-.2-8-1.68ZM165.89,35.01c1.88-.89,4.25-1.38,4.25-3.85,0-1.38-.99-2.17-2.47-2.17-3.36,0-3.26,4.05-1.78,6.02ZM160.95,43.9c-.3,3.95,5.43,4.64,7.8,2.47-1.78-1.98-3.36-4.15-4.74-6.62-1.78.79-2.96,1.98-3.06,4.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-14-ibu-on24-p1",
    d: "M214.18,33.43c0,3.95-2.27,6.02-5.33,6.91l6.62,10.27h-5.83l-5.63-9.28h-6.02v9.28h-5.14v-24.49c9.19.4,21.43-2.27,21.33,7.31ZM197.99,37.38c4.74-.2,11.06,1.19,11.06-3.75s-6.52-3.16-11.06-3.46v7.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-14-ibu-on24-p1",
    d: "M229.89,25.82c7.9,0,12.35,4.44,12.35,12.44s-4.54,12.74-12.44,12.74-12.25-4.74-12.25-12.74,4.35-12.44,12.35-12.44ZM229.79,46.96c5.14,0,7.21-3.46,7.21-8.69,0-4.94-2.07-8.49-7.11-8.49s-7.21,3.46-7.21,8.49,2.17,8.69,7.11,8.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-14-ibu-on24-p1",
    d: "M246.08,50.61v-24.49h5.14v24.49h-5.14"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-ibu-on24-p1",
    d: "M762.75,376.75v30.93"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-on24-p1",
    d: "M763,376.76h-.5v-.26h.5v.26Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-ibu-on24-p1",
    d: "M762.75,422.2l-4.63-14.27h9.27l-4.64,14.27Z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-ibu-on24-p1 ibu-on24-disable-rect",
    d: "M591.63,429.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    "data-name": "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-10",
    "data-name": "ae",
    className: "cls-14-ibu-on24-p1",
    d: "M627.56,468.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM627.56,483.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-5",
    "data-name": "aq",
    className: "cls-14-ibu-on24-p1",
    d: "M649.97,485.31l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-8",
    "data-name": "ar",
    className: "cls-14-ibu-on24-p1",
    d: "M661.51,468.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-5",
    "data-name": "as",
    className: "cls-14-ibu-on24-p1",
    d: "M678.76,481.5v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM676.72,470.91c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h-2",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-6",
    "data-name": "ai",
    className: "cls-14-ibu-on24-p1",
    d: "M696.41,472.13c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM695.87,483.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M703.81,485.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-14",
    "data-name": "ak",
    className: "cls-14-ibu-on24-p1",
    d: "M717.12,482.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM710.81,481.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-15",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M725.14,482.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-8",
    "data-name": "ao",
    className: "cls-14-ibu-on24-p1",
    d: "M734.78,469.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-16",
    "data-name": "ah",
    className: "cls-14-ibu-on24-p1",
    d: "M741.5,472.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM741.43,483.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-11",
    "data-name": "an",
    className: "cls-14-ibu-on24-p1",
    d: "M756.03,474.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-9",
    "data-name": "aj",
    className: "cls-14-ibu-on24-p1",
    d: "M770.63,473.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-14-ibu-on24-p1",
    d: "M791.27,472.13c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM790.73,483.95c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-14-ibu-on24-p1",
    d: "M802.75,485.58c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-8",
    "data-name": "ab",
    className: "cls-14-ibu-on24-p1",
    d: "M812.25,469.62v-2.04h2.17v2.04h-2.17ZM812.25,485.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "cls-14-ibu-on24-p1",
    d: "M817.62,485.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-16",
    "data-name": "ap",
    className: "cls-14-ibu-on24-p1",
    d: "M825.36,482.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "cls-14-ibu-on24-p1",
    d: "M842.74,472.13c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM842.2,483.95c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "cls-14-ibu-on24-p1",
    d: "M860.67,472.4l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-6",
    "data-name": "az",
    className: "cls-14-ibu-on24-p1",
    d: "M869.77,485.31v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-6",
    "data-name": "aA",
    className: "cls-14-ibu-on24-p1",
    d: "M885.18,476.41c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM878.59,475.66c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM878.59,483.47c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "cls-14-ibu-on24-p1",
    d: "M906.36,478.99c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-ibu-on24-p1",
    d: "M642.75,19.15c0-3.31,2.69-6,6-6h228c3.31,0,6,2.69,6,6v48c0,3.31-2.69,6-6,6h-228c-3.31,0-6-2.69-6-6V19.15Z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-14-ibu-on24-p1",
    d: "M698.26,50.26l-10.67-18.86c.59,5.73.2,12.64.3,18.86h-4.54v-24.49h5.83l10.86,19.06c-.59-5.73-.2-12.74-.3-19.06h4.54v24.49h-6.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-14-ibu-on24-p1",
    d: "M720.38,25.47c7.9,0,12.35,4.44,12.35,12.44s-4.54,12.74-12.44,12.74-12.25-4.74-12.25-12.74,4.35-12.44,12.35-12.44ZM720.28,46.61c5.14,0,7.21-3.46,7.21-8.69,0-4.94-2.07-8.49-7.11-8.49s-7.21,3.46-7.21,8.49,2.17,8.69,7.11,8.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-14-ibu-on24-p1",
    d: "M757.91,33.08c0,3.95-2.27,6.02-5.33,6.91l6.62,10.27h-5.83l-5.63-9.28h-6.02v9.28h-5.14v-24.49c9.19.4,21.43-2.27,21.33,7.31ZM741.72,37.03c4.74-.2,11.06,1.19,11.06-3.75s-6.52-3.16-11.06-3.46v7.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-14-ibu-on24-p1",
    d: "M762.16,25.77c11.85-.69,22.02.49,21.83,12.05-.1,7.9-4.35,12.44-11.95,12.44h-9.88v-24.49ZM767.3,46.31c7.31.69,11.56-1.78,11.56-8.49s-4.44-8.69-11.56-8.1v16.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-14-ibu-on24-p1",
    d: "M787.74,50.26v-24.49h5.14v24.49h-5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-14-ibu-on24-p1",
    d: "M801.86,37.92c0,5.23,2.07,8.59,7.21,8.69,3.65.1,5.33-2.17,6.42-4.64l4.44,1.68c-1.68,4.15-5.04,7.01-10.86,7.01-8.1,0-11.85-4.54-12.35-12.74-.69-10.86,10.77-15.41,19.36-10.57,1.78.99,2.86,2.86,3.56,4.94l-4.54,1.19c-.79-2.47-2.96-4.05-6.12-4.05-5.14,0-7.01,3.36-7.11,8.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-14-ibu-on24-p1",
    d: "M837.52,32.29c-.1-4.25-9.28-4.54-9.58-.3,1.78,6.52,14.91.99,15.21,11.26.3,9.38-16.3,9.19-20.15,3.56-.59-.79-.99-1.88-1.19-2.96l4.94-.79c.3,4.54,11.06,5.53,11.46.49-1.68-6.81-14.81-.99-15.21-11.26-.4-8.59,15.11-8.69,18.57-3.46.49.79.79,1.78.99,2.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbuOn24Phase1);
export default __webpack_public_path__ + "static/media/IbuOn24_Phase_1.b7a5c774e28e362a356d32f9cd2bbba5.svg";
export { ForwardRef as ReactComponent };